/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Trade } from './Trade';
import {
    TradeFromJSON,
    TradeFromJSONTyped,
    TradeToJSON,
} from './Trade';

/**
 * 
 * @export
 * @interface TradeHistoryPage
 */
export interface TradeHistoryPage {
    /**
     * 
     * @type {number}
     * @memberof TradeHistoryPage
     */
    totalNr: number;
    /**
     * 
     * @type {Array<Trade>}
     * @memberof TradeHistoryPage
     */
    trades: Array<Trade>;
    /**
     * 
     * @type {string}
     * @memberof TradeHistoryPage
     */
    asOfDate: string;
}

/**
 * Check if a given object implements the TradeHistoryPage interface.
 */
export function instanceOfTradeHistoryPage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "totalNr" in value;
    isInstance = isInstance && "trades" in value;
    isInstance = isInstance && "asOfDate" in value;

    return isInstance;
}

export function TradeHistoryPageFromJSON(json: any): TradeHistoryPage {
    return TradeHistoryPageFromJSONTyped(json, false);
}

export function TradeHistoryPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): TradeHistoryPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalNr': json['total_nr'],
        'trades': ((json['trades'] as Array<any>).map(TradeFromJSON)),
        'asOfDate': json['as_of_date'],
    };
}

export function TradeHistoryPageToJSON(value?: TradeHistoryPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_nr': value.totalNr,
        'trades': ((value.trades as Array<any>).map(TradeToJSON)),
        'as_of_date': value.asOfDate,
    };
}

